import { FeedbackTextValues } from 'pages/ParentHelper/components/Chat/components/Body/components/Answer/components/FeedbackButtons/components/FeedbackDislikeDialog/components/FeedbackDislikeDialogForm/constants';

import type { FeedbackType } from 'pages/ParentHelper/components/Chat/components/Body/components/Answer/components/FeedbackButtons/components/FeedbackDislikeDialog/types';
import type { PostApiParentHelperFeedbackByMessageIdArg as FeedbackPostType } from 'shared/api/gsp';

export const transformPostData = (feedback: FeedbackType): FeedbackPostType => {
  const transformedData: FeedbackPostType = {
    messageId: feedback.messageId,
    inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest: {
      liked:
        feedback
          .inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest
          .liked,
      feedbackText:
        feedback
          .inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest
          .feedbackText,
    },
  };

  if (
    feedback
      .inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest
      .feedbackText === FeedbackTextValues.other
  ) {
    transformedData.inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest.feedbackText =
      feedback.inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest.otherFeedbackText;
  }

  return transformedData;
};
